import { render } from "./InspectionThanks.vue?vue&type=template&id=60253286"
import script from "./InspectionThanks.vue?vue&type=script&lang=js"
export * from "./InspectionThanks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/InspectionThanks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60253286"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60253286', __exports__)) {
    api.reload('60253286', __exports__)
  }
  
  module.hot.accept("./InspectionThanks.vue?vue&type=template&id=60253286", () => {
    api.rerender('60253286', render)
  })

}


export default __exports__